import { ethers } from "ethers";

export function formatToken(value, decimals = 18, dp = 4) {
  if (!value) return "0.0000";
  try {
    const str = ethers.utils.formatUnits(value, decimals);
    const num = parseFloat(str);
    return num.toLocaleString("en-US", {
      minimumFractionDigits: dp,
      maximumFractionDigits: dp,
    });
  } catch {
    return "0.0000";
  }
}

export function truncateAddress(addr) {
  if (!addr) return "";
  return addr.slice(0, 6) + "..." + addr.slice(-4);
}

export function formatDate(timestamp) {
  if (!timestamp) return "";
  const ts = typeof timestamp === "number" ? timestamp : timestamp.toNumber();
  const d = new Date(ts * 1000);
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function copyToClipboard(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  }
}
